import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Flex, Spin } from 'antd';
import { UserAuth } from '../../middleware/UserContext/UserContext.middleware';
import { useCurrentUser } from '../hooks/useCurrentUser';

interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { currentUser } = UserAuth();
  const { isAdmin, isResolved } = useCurrentUser();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (!isResolved) {
    return (
      <Flex justify="center" style={{ padding: 48 }}>
        <Spin />
      </Flex>
    );
  }

  return isAdmin ? <>{children}</> : <Navigate to="/" />;
};

export default AdminRoute;
